import React, { Component } from 'react';
import Page from './Page';
import { connect } from 'react-redux';
import { Button, Typography, Box, ButtonGroup, Modal } from '@mui/material';
import { post } from '../util/api';
import { logout } from '../actions/access.actions';
import CancelIcon from '@mui/icons-material/Cancel';
import DoneIcon from '@mui/icons-material/Done';
import { load_product } from '../actions/product.actions';

const refresh = () => {
	setTimeout(() => {
		this.props.dispatch(load_product('maytapi'));
	}, 1000);
};

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 470,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
	textAlign: 'center',
};

class Trial extends Component {
	state = {
		openMainModal: true,
		openQuitModal: false,
		btnLoad: false,
	};

	areuSure = () => {
		this.setState({ openQuitModal: true, openMainModal: false });
	};

	StartTrial = async () => {
		this.setState({ btnLoad: true });
		let props = this.props;
		let pid = props.product.id;
		await post('/maytapi/createFreeTrial', { pid, type: 'api' }).then((data) => {
			if (data && data.data && data.data.success) {
				//
				post('/footprint/add', {
					category: 'maytapi',
					label: 'checkout-start',
					extra: {
						pid: pid,
						uid: props.access.user.loggedUserObj.id,
						plan: 'trial',
					},
				});
				window.location.reload(false);
			} else {
				refresh();
				//this.setState({ messageOnScreen: data.data.message });
			}
		});
		this.setState({ btnLoad: false });
	};
	isSpamEmail(email) {
		// Email formatının geçerli olup olmadığını kontrol ediyoruz
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (!emailRegex.test(email)) {
			return true; // Geçersiz format
		}

		// Bu regex, en az iki harf ve iki rakam içeren ve 15 karakterden uzun yerel kısımları yakalamayı hedefler
		const spamRegex = /^[a-z0-9]{2}([a-z]|[0-9]){28}/;

		const localPart = email.split('@')[0];
		if (spamRegex.test(localPart)) {
			return true;
		}

		return false;
	}
	render() {
		let { access } = this.props;
		let email = access.user && access.user.loggedUserObj && access.user.loggedUserObj.email;
		return (
			<Page>
				<style
					dangerouslySetInnerHTML={{
						__html: `
						.ui.page.modals.dimmer{
							z-index:999999999999 ;
						}`,
					}}
				/>
				<Modal
					sx={{ background: '#000000ad' }}
					hideBackdrop
					open={this.state.openMainModal}
					onClose={this.handleClose}
					aria-labelledby="child-modal-title"
					aria-describedby="child-modal-description"
				>
					<Box sx={style}>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							WELCOME TO MAYTAPI!
						</Typography>
						<Typography>
							<Typography variant="h3">Unofficial WhatsApp API for Developers</Typography>
							<Typography variant="h4">(Multi-device Supported API)</Typography>
							<img
								src="/maytapi_full.svg"
								alt="/maytapi_full.svg"
								style={{
									width: '12rem',
									background: '#009687',
									padding: '12px',
									borderRadius: '3px',
									margin: '10px',
								}}
							/>
							<Typography variant="h6">
								Powerful WhatsApp API that enables you to send, receive and track WhatsApp message effortlessly
							</Typography>
							<br />
							<Typography>
								Free Trial 3 Days <br />
								No Credit Card Required <br />
								Cancel Anytime
							</Typography>
						</Typography>
						<Typography id="modal-modal-description" sx={{ mt: 2 }}>
							<ButtonGroup>
								<Button variant="outlined" onClick={() => this.areuSure()} startIcon={<CancelIcon />}>
									Logout
								</Button>
								<Button
									loading={this.state.btnLoad}
									disabled={this.isSpamEmail(email)}
									variant="outlined"
									onClick={this.StartTrial}
									startIcon={<DoneIcon />}
								>
									Start Trial
								</Button>
							</ButtonGroup>
						</Typography>
					</Box>
				</Modal>
				<Modal open={this.state.openQuitModal}>
					<Box sx={style}>
						<Typography>Are you want to quit?</Typography>
						<ButtonGroup sx={{ marginTop: '15px' }}>
							<Button variant="outlined" onClick={() => this.setState({ openMainModal: true, openQuitModal: false })} startIcon={<CancelIcon />}>
								Cancel
							</Button>
							<Button loading={this.state.btnLoad} variant="outlined" onClick={() => this.props.logoutUser()} startIcon={<DoneIcon />}>
								Quit
							</Button>
						</ButtonGroup>
					</Box>
				</Modal>
			</Page>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	logoutUser: () => dispatch(logout()),
});

const stateToProps = (state) => ({ access: state.access, product: state.product.maytapi, location: state.router.location });
export default connect(stateToProps, mapDispatchToProps)(Trial);
